import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { feedMappingSchema, uiSchema } from './Schema';

export default class FeedMappingEditor extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onUpdate(formData);
  };

  render() {
    const { fetching, feedMapping } = this.props;

    return (
      <div className="form-list-container">
        <Form
          schema={feedMappingSchema}
          uiSchema={uiSchema}
          formData={feedMapping}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

FeedMappingEditor.propTypes = {
  fetching: PropTypes.bool,
  feedMapping: PropTypes.object,
  onUpdate: PropTypes.func,
};
